import { authSplitApi } from 'redux/helpers/slice.helpers';
import { TSupportTicketResponse } from 'components/HelpSupport/HelpSupportModal.types';

export const SUPPORT_TICKET_URL = 'api/support/ticket';

export const supportApi = authSplitApi('supportApi').injectEndpoints({
  endpoints: build => ({
    createSupportTicket: build.mutation<TSupportTicketResponse, FormData>({
      query(body) {
        return {
          url: SUPPORT_TICKET_URL,
          method: 'POST',
          body,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useCreateSupportTicketMutation } = supportApi;
